import Swiper from 'swiper';
import 'swiper/css';
export default class UltimosPostsList {
    constructor() {
        this.sections = document.querySelectorAll('.block-latest-posts');
        this.ready();
    }

    ready() {

        if (this.sections.length > 0) {
            this.sections.forEach((section) => {
                this.slider = section.querySelector('.swiper');
                const swiper = new Swiper(this.slider, {
                    grabCursor: true,
                    allowTouchMove: true,
                    spaceBetween: 28,
                    breakpoints: {
                        0: {
                            slidesPerView: 1.2,
                            slidesOffsetAfter: 28,
                            slidesOffsetBefore: 28
                        },
                        1200: {
                            slidesPerView: 4,
                            slidesOffsetAfter: 0,
                            slidesOffsetBefore: 0
                        }
                    }
                });

            })
        }

    }
}

if (document.querySelector('.block-latest-posts')) {
    new UltimosPostsList();
}